var _path, _path2, _path3, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditLayout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9156_13220)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_9156_13220",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 0H0V24H24V0Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_9156_13220)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_9156_13220",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24 0H0V24H24V0Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_9156_13220)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask2_9156_13220",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24 0H0V24H24V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_9156_13220)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.3726 18.6274 0 12 0C5.3726 0 0 5.3726 0 12C0 18.6274 5.3726 24 12 24Z",
    fill: "url(#paint0_linear_9156_13220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0273 10.1723C15.8366 10.1723 15.6819 10.3269 15.6819 10.5177V16.8247C15.6819 17.4911 15.1396 18.0335 14.4731 18.0335H6.89964C6.23315 18.0335 5.69078 17.4911 5.69078 16.8247V9.25114C5.69078 8.58466 6.23315 8.04232 6.89964 8.04232H14.4731C14.6638 8.04232 14.8185 7.88768 14.8185 7.69694C14.8185 7.5062 14.6638 7.35156 14.4731 7.35156H6.89964C5.85216 7.35156 5 8.20369 5 9.25114V16.8247C5 17.8721 5.85216 18.7242 6.89964 18.7242H14.4731C15.5205 18.7242 16.3727 17.8721 16.3727 16.8247V10.5177C16.3727 10.327 16.2181 10.1723 16.0273 10.1723Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.6863 5.58859C18.2699 5.17221 17.5925 5.17238 17.1765 5.58859L11.2604 11.5048C11.2525 11.5127 11.1633 11.6055 11.1402 11.6574L10.3209 13.498C10.2627 13.6287 10.291 13.7816 10.3922 13.8827C10.4583 13.9488 10.5467 13.9838 10.6366 13.9838C10.684 13.9838 10.7317 13.9741 10.7769 13.9539L12.6175 13.1347C12.6693 13.1116 12.7621 13.0224 12.7701 13.0145L18.6863 7.09846C18.888 6.89675 18.9991 6.62862 18.9991 6.34344C18.9991 6.05828 18.888 5.7901 18.6863 5.58859ZM18.1979 6.6099L12.2817 12.5261C12.2807 12.5271 12.2801 12.5283 12.2792 12.5291L11.3178 12.9571L11.7458 11.9957C11.7466 11.9947 11.7478 11.9942 11.7488 11.9932L17.6648 6.07701C17.8074 5.93447 18.0557 5.93464 18.1979 6.07715C18.2692 6.14815 18.3084 6.24277 18.3084 6.34344C18.3084 6.44411 18.2691 6.5387 18.1979 6.6099Z",
    fill: "white"
  })))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_9156_13220",
    x1: 12,
    y1: 0,
    x2: 12,
    y2: 24,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0C0C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A5A5A"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9156_13220"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditLayout);
export default __webpack_public_path__ + "static/media/edit-layout.e316a8a4e00dbdd3af3cfeaf80529a5c.svg";
export { ForwardRef as ReactComponent };